import { checkStatus } from './states';

export const services = {
  checkStatus,
};
